import { CUSTOM_ELEMENTS_SCHEMA, NgModule, Type } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserNotificationComponent } from './user-notification/user-notification.component';


@NgModule({
  declarations: [UserNotificationComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule
  ],
  exports: [UserNotificationComponent]
})
export class UserNotificationModule {
  customElementComponent: Type<any> = UserNotificationComponent;
}
